/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 17 2023
 **/

import { css } from "@emotion/react";

import { hoverScrollCss } from "@/frameworks/designStuff/utils";

export const groupCss = (isMouseDown = true) => {
	return css`
		${isMouseDown ? "" : "transition: height 0.3s ease-in-out;"}
		flex-direction: column;
		overflow-x: hidden;
		overflow-y: hidden;
	`;
};

export const headerCss = () => {
	return css``;
};

export const wrapCss = () => {
	return css`
		display: flex;
		flex-direction: column;
		height: 100%;
	`;
};

export const bodyCss = hoverScrollCss;

export const dragWrapCss = (isDraggable: boolean) => {
	if (isDraggable) {
		return css`
			height: 100%;
			overflow: hidden;
		`;
	} else {
		return css`
			height: 100%;
		`;
	}
};
